export default function TrustIndicators() {
  const stats = [
    { number: "Over 1,200", label: "luxury waterfront properties listed in South Florida" },
    { number: "Over $2.8B", label: "in active South Florida waterfront listings" },
    { number: "25+", label: "South Florida luxury neighborhoods covered" },
    { number: "98%", label: "of buyers start their search online" },
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {stats.map((stat, index) => (
            <div key={index}>
              <div className="text-4xl font-playfair font-bold text-ocean-blue mb-2">
                {stat.number}
              </div>
              <div className="text-deep-navy">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
